import { CreateCaseDialog } from '@/components/cases/CreateCaseDialog'
import { DeleteCaseDialog } from '@/components/cases/DeleteCaseDialog'
import type { Case } from '@/services/api'
import { useCreateCase } from './hooks/useCreateCase'
import { useDeleteCase } from './hooks/useDeleteCase'

export function CreateCaseDialogConnected({
  open,
  onOpenChange,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const { createCase, creating, error } = useCreateCase({ onSuccess: () => onOpenChange(false) })
  return (
    <CreateCaseDialog
      open={open}
      onOpenChange={onOpenChange}
      onSubmit={createCase}
      creating={creating}
      error={error}
    />
  )
}

export function DeleteCaseDialogConnected({
  open,
  onOpenChange,
  caseData,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  caseData: Case | null
}) {
  const { deleteCase, deleting } = useDeleteCase({ onSuccess: () => onOpenChange(false) })
  return (
    <DeleteCaseDialog
      open={open}
      onOpenChange={onOpenChange}
      caseData={caseData}
      onConfirm={deleteCase}
      deleting={deleting}
    />
  )
}
